//src/constants/productImageMap.ts

export const PRODUCT_IMAGE_MAP: Record<number, string> = {
  4993: 'Bimix.png',
  4994: 'Super Bimix.png',
  4997: 'Quadmix.png',
  4998: 'Super Quadmix.png',
  5009: 'Sildenafil.png',
  5012: 'Tadalafil.png',
  5016: 'Tadalafil.png',
  5577: 'Sildenafil.png',
  5019: 'Trimix.png',
  5576: 'Super Trimix.png',
  5578: 'Sildenafil.png',
  5579: 'Tadalafil.png',
  5580: 'Tadalafil.png',
  5602: 'Phenylephrine HCL.png',
  7317: 'Trimix.png',
  7319: 'Super Trimix.png',
  7321: 'Quadmix.png',
  7323: 'Super Quadmix.png',
  7325: 'Bimix.png',
  7327: 'Super Bimix.png',
  7342: 'Trimix.png',
  7344: 'Trimix.png',
  5720: 'Sildenafil.png',
  5721: 'Tadalafil.png',
  5723: 'Vardenafil.png',
  5516: 'needle.png',
  5520: 'needle.png',
  5894: 'needle.png',
};